export function StatusBadge({ health, size = "sm" }) {
    const map = {
        healthy: { bg: "bg-[#16A34A]/10", text: "text-[#16A34A]", border: "border-[#16A34A]/20", dot: "bg-[#16A34A]", label: "Healthy" },
        warning: { bg: "bg-[#F97316]/10", text: "text-[#F97316]", border: "border-[#F97316]/20", dot: "bg-[#F97316]", label: "Warning" },
        critical: { bg: "bg-red-500/10", text: "text-red-600", border: "border-red-500/20", dot: "bg-red-500", label: "Critical" },
    };
    const s = map[health] || map.healthy;
    return (
        <span className={`inline-flex items-center gap-1.5 ${s.bg} ${s.text} ${s.border} border rounded-full font-mono text-xs px-2.5 py-0.5`} data-testid={`badge-${health}`}>
            <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
            {s.label}
        </span>
    );
}
